'use client';
// TODO: need to optimize size of the Footer bundle, today it makes html bigger = page loading slower
import { useEffect, useState } from 'react';

import LayoutFooterSkeleton from '@/app/voyage-planner/(with-header)/@footer/skeleton';
import ReCaptchaLabel from '@/components/ReCaptcha/ReCaptchaLabel';
import CMSComponent from '@/helpers/cms/CMSComponentSSR';
import { getFooterContent } from '@/helpers/cms/content';
import { type TCMSContent } from '@/types';

const LayoutFooter = () => {
  const [content, setContent] = useState<TCMSContent>();

  useEffect(() => {
    getFooterContent().then((value) => setContent(value));
  }, []);

  if (!content) {
    return <LayoutFooterSkeleton />;
  }

  return (
    <>
      <ReCaptchaLabel inFooter />
      <CMSComponent data={content} />
    </>
  );
};

export default LayoutFooter;
